/*
  <mh-card-slides> — photos d'une carte produit qui défilent au doigt sur mobile (snippets/mh-card-product.liquid,
  paramètre swipe). Le défilement est natif (scroll-snap) ; ce script met à jour le point indicateur actif.
*/
if (!customElements.get('mh-card-slides')) {
  customElements.define('mh-card-slides', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-mh-card-slides-track]');
      this.dots = [...this.querySelectorAll('.mh-card-product__dot')];
      if (!this.track || this.dots.length < 2) return;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => {
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        });
      }, { passive: true });
    }
  });
}
